import React, { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, errorInfo) {
    console.error(error, errorInfo);
    this.setState({ hasError: true });
  }
  handleClick = () => {
    window.open(this.props.fallbackLink, "_blank");
    console.log(this.props.fallbackLink);
  };

  render() {
    if (this.state.hasError) {
      const { type, fallbackLink } = this.props;
      return (
        <div
          style={{
            color: "white",
            marginLeft: "7%",
            position: "relative",
            zIndex: 1000,
            pointerEvents: "auto",
          }}
        >
          {fallbackLink && (
            <div
              style={{
                position: "relative",
                zIndex: 1001,
                pointerEvents: "auto",
              }}
            >
              <button
                onClick={() => {
                  const win = window.open(fallbackLink, "_blank");
                  if (win) win.focus();
                }}
                style={{
                  color: "white",
                  backgroundColor: "black",
                  border: "1px solid #4a90e2",
                  padding: "8px 16px",
                  cursor: "pointer",
                  borderRadius: "4px",
                  position: "relative",
                  zIndex: 1002,
                  pointerEvents: "auto",
                }}
              >
                Seuraa {type}issa
              </button>
            </div>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}
